import React, {useEffect, useRef} from 'react';
import WebView from 'react-native-webview';
import BottomSheet from '../../../../../Interface/BottomSheet';
import {Dimensions, View} from 'react-native';
import {
  startCheckoutForegroundService,
  stopCheckoutForegroundService,
} from '../../../../../../utils/foregroundService';

import {CloseButton, CloseButtonIcon} from './styles';
import {api} from '../../../../../../services/api';


interface Props {
  html: string;
  isOpen: boolean;
  onCancel: () => void;
  onLoaded?: () => void;
  onNavigationStateChange?: (navState: any) => void;
  ds_trans_id: string;
}

export default function GetnetWebview3ds({
  html,
  isOpen,
  onCancel,
  onLoaded,
  onNavigationStateChange,
  ds_trans_id,
}: Props) {
  const webRef = useRef<WebView>(null);
  const screenHeight = Dimensions.get('window').height;

  useEffect(() => {
    if (!isOpen) return;
    startCheckoutForegroundService();
    return () => {
      stopCheckoutForegroundService();
    };
  }, [isOpen]);

  const handleLoad = async () => {
    onLoaded?.();

    try {
      await api.post('/payments/recebe_verifica_desafio', {
        ds_trans_id,
        renderizou: 'true',
      });
    } catch (error) {
      console.error('Erro ao enviar verificação do desafio', error);
    }
  };



  const handleNavChange = (navState: any) => {
    onNavigationStateChange?.(navState);
  };

  async function handleError() {
    try {
      await api.post('/payments/recebe_verifica_desafio', {
        ds_trans_id,
        renderizou: 'false',
      });
    } catch (error) {
      console.error('Erro ao enviar verificação do desafio', error);
    }
  }



  return (
    <BottomSheet isOpen={isOpen} onClose={onCancel} disableKeyboardAvoidance>
      <View style={{height: screenHeight * 0.9}}>
        <CloseButton onPress={onCancel}>
          <CloseButtonIcon name="x" />
        </CloseButton>
        <WebView
          ref={webRef}
          style={{flex: 1}}
          originWhitelist={['*']}
          source={{html, baseUrl: 'https://localhost'}}
          onLoad={handleLoad}
          onHttpError={handleError}
          onError={handleError}
          onNavigationStateChange={handleNavChange}

          javaScriptEnabled={true}
          domStorageEnabled={true}
          scrollEnabled={true}
          startInLoadingState={true}
          mixedContentMode="always"
          sharedCookiesEnabled={true}
          thirdPartyCookiesEnabled={true}
        />
      </View>
    </BottomSheet>
  );
}
